export function menuFunc() {
    var spActionBtn, spActionColumn,aTagTxt,setTxt;
    spActionBtn = '.spActionBtn';
    spActionColumn = '.spActionColumn';
    $(spActionBtn).on('click', function () {
        $(this).toggleClass('open');
        aTagTxt = $(this).find('a').text();
        console.log(aTagTxt);
        $(this).parent().find(spActionColumn).toggleClass('open');
        if ($(this).parent().find(spActionColumn).hasClass('open')) {
            $(this).parent().find(spActionColumn).slideDown("slow");
            setTxt = aTagTxt.replace("すべての", "").replace("見る", "閉じる");
            $(this).find('a').text(setTxt);
        }else{
            $(this).parent().find(spActionColumn).slideUp("slow");
            setTxt = aTagTxt.replace("閉じる", "見る");
            $(this).find('a').text("すべての"+setTxt);
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/js/pages/_menu.js
// module id = 16
// module chunks = 0